import { VStack } from "@/components/ui/vstack";
import { Image } from "@/components/ui/image";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import React, { useState } from "react";
import i18n from "i18n-js";
import { saveImageAsync } from "@/stores/thunks";
import { useSelector, useDispatch } from "react-redux";
import FloatingLabelInput from "@/components/basic/FloatingLabelInput";
import BasicButton from "@/components/basic/BasicButton";
import CancelButton from "@/components/basic/CancelButton";

export default function ModalSupport({ route, navigation }) {

    const { uri, screen } = route.params
    const dispatch = useDispatch()
    let [info, setInfo] = useState('');

    const data = useSelector((state) => {
        let data = { ...state };
        // [ 'version', 'changed', 'init', 'users', 'images', 'icons', 'remote', 'temp', 'legal', 'user', 'server', 'workflows', 'tasks', 'planned', 'contacts', 'settings', 'deleted', 'published']
        console.log(data.temp.perfs)
        data.perfs = data.temp.perfs;
        ['active', 'init', 'users', 'icons', 'temp', 'legal', 'remote'].forEach(key => delete data[key])
        return JSON.stringify(data)
    })

    return (
        <View className="flex-1 bg-[#00000050] justify-center">
            <VStack space='sm' className="m-3 bg-secondary-50 px-4 py-5 rounded-[5px]">
                <Text className="text-2xl font-[600] text-secondary-900 bg-secondary-50">{i18n.t('support.title')}</Text>
                <Text className="text-lg my-2 font-[600] text-secondary-900 bg-secondary-50">{i18n.t('support.reason')}</Text>
                <View className="w-[100%]">
                    <FloatingLabelInput label={i18n.t('support.description')} h='h-[100px]' multiline={true} maxLength={250} returnKeyType='done' blurOnSubmit={true} onChangeText={setInfo} value={info} />
                </View>
                <Image key={uri} source={{ uri: uri }} alt={i18n.t('global.missingImage')} resizeMode='contain' className="self-center border-[2px] border-primary-900 rounded-4 h-[200px] w-[200px]" />
                <BasicButton onPress={() => {
                        dispatch(saveImageAsync('IMAGE_SCREENSHOT', '/supportdata/screenshot', { uri: uri, title: screen, description: info, data: data })); navigation.goBack()
                    }} text={i18n.t('support.send')}/>
                <CancelButton onPress={() => { navigation.goBack() }} text={i18n.t('support.cancel')}/>
            </VStack>
        </View>
    );
}
/*
  cvt["maxLength="]=0
*/
